<template>
  <div class="flex flex-row justify-center min-h-svh bgColor-figma w-full overflow-x-hiddenn">
    <NuxtLoadingIndicator :color="loadingColor" />
    <div class="w-full mx-auto overflow-hidden">
      <div class="flex flex-col min-h-svh justify-center ">

        <!-- <div class="sticky top-0 z-50 w-full bg-gradient-to-b from-[#FDF5DE] to-gray-50"> -->
        <header ref="headerRef" class="fixed top-0 left-0 z-50 w-full" :class="[ partnerId.toLowerCase() === 'oneindiamall' ? 'bg-primary bg-gradient-to-b from-[#CA5096] to-[#ea71b5]' : 'bg-white' ]"
          :style="getComponentStyle(navbarConfig.style)">
          <div
            v-if="runtimeConfig.public.partnerName === 'HPCL'"
            class="
              absolute inset-0 -z-10 w-full h-full bg-no-repeat bg-cover bg-left-top
              bg-[url('/v1/hpcl-mobile-header.jpeg')]
              sm:bg-[url('/v1/hpcl-header.jpeg')]
            "
          ></div>
          <div class="md:container px-1.5 w-full" v-if="!isNavDisabled">
            <V2NavbarComponent />
            <!-- Search: only on small screens -->
            <div v-if="showSearchFinal" class="block md:hidden w-full  mb-2 px-3">
              <div class="w-full rounded-md overflow-hidden">
                <V2SearchComponent :placeholder="categories" />
              </div>
            </div>
          </div>
        </header>
        <!-- <div :class="bgImageClass" class="flex justify-center sticky top-0 z-50 w-full h-full">
          <div class="md:container px-1.5 w-full" v-if="!isNavDisabled">
            <V2NavbarComponent :textColor="bgImageClass.includes('text-white') ? 'white' : 'black'" />
            
            <div v-if="showSearch" class="block md:hidden w-full  mb-2 px-3">
              <div class="w-full rounded-md overflow-hidden">
                <V2SearchComponent :placeholder="categories"/>
              </div>
            </div>
          </div>
        </div> -->

        <!-- <header class="bg-gray-300 z-40 text-white sticky top-0">
          <div class="md:container md:self-center mx-auto">
            <slot name="header"></slot>
          </div>
        </header> -->
        <main class="flex-grow md:container md:self-center overflow-clip md:pb-0" :style="{ marginTop: headerHeight + 'px' }"
         :class="[
            financeApp ? 'h-[calc(100svh-76px)]' : '',
            partnerId.toLowerCase() === 'oneindiamall' ? 'pb-16' : 'pb-16'
          ]">
          <div class="cursor-pointer" @click="scrollToTop" v-show="isVisible">
          <div class="fixed z-50 top-[120px] md:top-[80px] left-1/2 -translate-x-1/2 w-fit h-fit">
              <button
                class="flex items-center justify-center w-[140px] h-[40px] rounded-lg bg-[rgba(22,38,54,0.8)] hover:bg-[rgba(22,38,54,0.9)] text-white transition-colors duration-200 shadow-lg gap-1 md:gap-[4px] px-2 py-2.5 md:p-0">
                <div class="flex items-center justify-center w-5 h-5 rounded-full flex-shrink-0">
                  <template v-if="partnerId.toLowerCase() === 'oneindiamall'">
                    <UIcon name="i-heroicons-arrow-up" variant="solid" class="w-5 h-5" />
                  </template>
                  <template v-else>
                    <img src="/v2/images/up.png" alt="Up arrow" title="Up arrow" class="w-23 h-23" />
                  </template>
                </div>
                <span class="font-medium text-sm whitespace-nowrap">Back to Top</span>
              </button>
            </div>
          </div>
          <!-- <div
            v-show="isVisible"
            class="w-full flex justify-center fixed z-50"
          >
            <div
              @click="scrollToTop"
              class="cursor-pointer text-center scrollToTop"
            >
              <UIcon
                name="i-heroicons-arrow-up"
                variant="solid"
                class="text-primary mTop h-5 w-5"
              />

              <p class="text-primary mTop h-5 w-5">Back to Top</p>
            </div>
          </div> -->
          <!-- NOTE: Not sure - this parent level keep alive here is'nt working.  -->
          <KeepAlive>
            <slot name="main" :class="{ 'mb-8': !(financeApp || hasNoBottom) }" />
          </KeepAlive>

          <V3PageLoaderComponent v-if="isLoading && showLoader && route.path !== '/account/orders'"
            class="dark:text-black fixed top-0 left-0 w-full h-full flex items-center justify-center bg-white/80 z-50" />
          <div v-if="route.path !== '/categories/search-v2' && partnerId.toLowerCase() !== 'oneindiamall'" class="md:p-8">
            <V2OrderSummaryFooter v-if="page === 'orderSummary'" />
            <slot name="footer"v-else-if="!isGroceryFooter && !route.meta.hideFooter" >
              <V2Footer />
            </slot>
          </div>
        </main>
        <footer ref="footerRef"
          class="flex flex-col fixed bottom-0 w-full z-10 sm:shadow-2xl sm:border-t">
          <slot name = "payfooter"></slot>
          <slot name="providerfooter"></slot>
          <slot name="footer"></slot>
          <!-- start: footer navigation for mobile view -->
          <div v-if="showFooterNavigation" class="sm:hidden w-full flex justify-between bg-white px-2 overflow-scroll">
            <div v-for="item in navIcons.footerNavIcons" :key="item.name" @click="handleFooterClick(item)"
              class="min-w-14 w-full relative pt-2 px-2 py-2 cursor-pointer">
              <div class="flex flex-col items-center justify-between">
                <!-- <div v-if="isActiveFooterItem(item)" class="absolute top-0 w-full h-[5px] bg-orange-500 rounded-b-xl">
                </div> -->
                <div class="flex flex-col items-center justify-center pt-1 rounded-lg"
                  :style="isActiveFooterItem(item) ? { 'background-color': activeBgColor } : ''">
                  <!-- <div class="flex flex-col items-center justify-center pt-1 rounded-lg" :style="{ 'background-color': isActiveFooterItem(item) ? activeBgColor : ''}"> -->
                  <div>
                    <span v-if="item.badge && item.badge > 0"
                      class="absolute top-2 right-4 bg-[#D00B0B] text-white text-xs leading-3 rounded-full h-4 w-4 flex items-center justify-center">
                      {{ item.badge }}
                    </span>
                    <img :src="isActiveFooterItem(item) ? item.activeIcon : item.icon
                      " class="w-6 h-6" :alt="item.label || 'Footer Icon'" :title="item.label || 'Footer Icon'" />
                  </div>
                  <p class="px-0.5 text-center text-xs leading-5 text-navyPrime w-16 truncate"
                    :class="{ 'text-primary-600': isActiveFooterItem(item) }"
                    :style="isActiveFooterItem(item) ? { 'color': isColorType(), fontWeight : 'bold' } : ''">
                    {{ item.label }}
                  </p>
                </div>
              </div>
            </div>
          </div>
          <!-- end: footer navigation for mobile view -->
        </footer>

        <UNotifications />
        <USlideovers />
        <UModals />
        <V2Overlay v-model="isPopupOpen" :container-class="'pt-6 pr-4 pl-4 pb-1 md:pb-6'">
          <V2LoginComponent @close="closeOverlay" />
        </V2Overlay>

        <V2Overlay v-model="isLocationPickerOpen" :container-class="'pt-3 pr-4 pl-4 pb-1 md:pb-6'">
          <V2LocationPickerComponent @success="handleLocationSuccess" @close="closeLocationPicker" />
        </V2Overlay>
        <V2Overlay v-model="isLocationUpdateOpen"
          :container-class="'pt-6 pr-4 pl-4 pb-1 md:mb-3 overflow-y-auto w-full max-h-[70vh]'">
          <V2LocationUpdate @success="handleLocationUpdateSuccess" @close="closeLocationUpdate" />
        </V2Overlay>
        <V2Overlay
          v-model="isLocationChangeOpen"
          :container-class="'pt-6 pr-4 pl-4 pb-1 md:mb-3 overflow-y-auto w-full max-h-[70vh]'"
        >
          <V3LocationChangeComponent
            @success="proceedLocationChange"
            @close="closeLocationChange"
        />
      </V2Overlay>
        <LoginBanner :message="loginBannerMessage" :footer-height="footerHeight" />

      </div>
    </div>
  </div>
</template>

<script setup>
import { V2LocationUpdate, V3PopupComponent } from "#components";
import { V3ModalComponent } from "#components";
import { ref, onMounted, nextTick, computed } from 'vue'
import LoginBanner from '@/components/v4/LoginBanner.vue'
import { useLoginBanner } from '@/composables/useLoginBanner'
import { useLocationPicker } from '~/composables/v2/use.location.picker'
import { useAutoFetchLocation } from '~/composables/location/useAutoFetchLocation'
import { setPostAuthRedirect } from '~/utility/authRedirect';
import { useGoogleAnalytics } from "~/composables/analystics/useGoogleAnalytics";
import { GoogleAnalytics } from "~/google_analytics/events";
import { useScrollTracking } from "~/composables/analystics/useScrollTracking";
import { EventParameter } from "~/google_analytics/events.enum";


const {
  isLocationPickerOpen,
  handleLocationSuccess,
  closeLocationPicker,
  isLocationUpdateOpen,
  handleLocationUpdateSuccess,
  closeLocationUpdate,
  isLocationChangeOpen,
  currentLocationCoord,
  closeLocationChangePopup,
  openLocationChangePopup
} = useLocationPicker()

useScrollTracking();

const { loginBannerMessage } = useLoginBanner()
const route = useRoute();
const { isMobile, isDesktop } = useDevice();
const safeRouteName = computed(() => route.name ? route.name.toString().toLowerCase() : '');
const blacklist = ["location-finder", 'loans'];
const isNavDisabled = computed(() => blacklist.includes(safeRouteName.value));
const isVisible = ref(false);
const lastScrollPosition = ref(0);
const isPopupOpen = ref(false);
const activeBgColor = ref("");
const geoStore = useGeoLocation();

const proceedLocationChange = async () => {
  closeLocationChangePopup();

  const locationStore = useGeoLocation();

  await locationStore.setLocationByCoordinates(currentLocationCoord.value.latitude, currentLocationCoord.value.longitude);
  // Reload parent if inside iframe, else reload current window
  if (window.self !== window.top) {
    window.top?.location.reload();
  } else {
    window.location.reload();
  }
};

const closeLocationChange = async () => {
  closeLocationChangePopup();
}

const closeOverlay = () => {
  isPopupOpen.value = false;
};

const isGroceryFooter = route.path.includes('/categories') && route.query.parent === 'grocery';
const paths = [
  // "/providers",
  "/categories",
  "/categories/v2",
  "/deals",
  "/",
  "/collections/mahaKumbh",
  "/collections",
  "/categories/search",
  "/categories/search-v2",
];
const footerNavPreHandlers = [
  {
    routeName: "__all__",
    preHandlers: [
      () => {
        return route.query && route.query?.from !== "checkout";
      },
      () => {
        return route.path !== "/checkout";
      },
      // for routes like ocalhost:3001/order-summary
      () => {
        return route.path !== "/order-summary";
      },
      () => {
        return route.path !== "/select-location";
      },
    ],
  }, // Default handler to show footer navigation
];

const footerRef = ref(null);
const footerHeight = ref(0);
const updateFooterHeight = () => {
  if (footerRef.value) {
    footerHeight.value = footerRef.value.offsetHeight;
  }
};
const runtimeConfig = useRuntimeConfig();
const partnerId = runtimeConfig.public.partnerCode;
const isDark = ref(false);
const slideover = useSlideover();
const modal = useModal();
const navIcons = useNavIcons();
const { isLoading } = useLoadingIndicator();
const showLoader = computed(() => route.meta.showLoader ?? true);
const { gtag } = useGtag();
const auth = useAuth();
const analyticsEvents = useAnalyticsEvents();
const navbarConfig = reactive({});
const headerRef = ref(null)
const headerHeight = ref(0)
const nuxtApp = useNuxtApp()
const isAuthenticated = auth && auth.access_token;
const userData = isAuthenticated
  ? {
    user_name: auth.user.first_name,
    user_phone: auth.user.phone,
    user_email: auth.user.email,
  }
  : {
    user_name: null,
    user_phone: null,
    user_email: null,
  };
const location = useLocation();
const bgImageClass = computed(() => {
  if (route.path.toLowerCase() === "/" || route.path.toLowerCase() === "/homepagev2") {
    return "bg-contain bg-center md:bg-[url('/v2/banner/FestiveHeaderDesktop.jpeg')] bg-[url('/v2/banner/FestiveHeaderMobile.jpeg')]";
  } else if (route.path.toLowerCase() === "/deals") {
    return "bg-[#7F1439] text-white";
  } else {
    return "bg-gradient-to-b from-[#FDF5DE] to-gray-50 text-black";
  }
});
const loadingColor = computed(() => {
  if (partnerId?.toLowerCase() === 'oneindiamall') {
    return `linear-gradient(180deg, #ea71b5, #CA5096)`;
  }  
  return undefined; 
});
const { data: categoryResult } = await useAPIHandler("get", "/categories");
const categories = categoryResult.categories
  .filter((k) => k.displayName !== "Appliances")
  .map((k) => k.displayName)
  .sort((a, b) => a.localeCompare(b));

const hideSearchPatterns = [
  '/categories/search-v2',
  '/shop', // will match all routes starting with /shop
  '/providers',
  '/cart',
  '/coupons',
  '/collections/giftcards',
  '/collections/gift-cards',
  'collections/gift-cards/cart',
  '/account/orders',
  '/search',
  '/v2/search',
  '/filter/v2'
];

const isEmiCategory = computed(() => {
  return route.query.parent === 'emi';
});

const showSearch = computed(() => {
  // check if the current route matches any hide pattern and partnerId is not 'fintastics'
  return !hideSearchPatterns.some(pattern => route.path.startsWith(pattern)) && partnerId.toLowerCase() !== 'fintastics';
});

const showSearchFinal = computed(() => {
  return showSearch.value && !isEmiCategory.value;
});

const getPartner = async () => {
  const { data: partner } = await useAPIHandler("get", "/partners", {
    query: { id: partnerId },
  });
  if (route.path.toLowerCase() === "/" || route.path.toLowerCase() === "/homepagev2") {
    Object.assign(navbarConfig, partner.cmsV2.navbarConfig["homepage"]);
  } else if (route.path.toLowerCase() === "/deals") {
    Object.assign(navbarConfig, partner.cmsV2.navbarConfig["deals"]["allDeals"]);
  } else if (route.path.toLowerCase() === "/categories/v2") {
    Object.assign(navbarConfig, partner.cmsV2.navbarConfig["allCategories"]);
  } else if (route.path.toLowerCase() === "/categories" && route.query.parent) {
    Object.assign(navbarConfig, partner.cmsV2.navbarConfig["categories"][route.query.parent]);
  } else if (route.path.toLowerCase().startsWith("/shop") && route.params.id) {
    Object.assign(navbarConfig, partner.cmsV2.navbarConfig["categories"][route.params.id]);
  } else if (route.path.toLowerCase() === "/collections/giftcards") {
    Object.assign(navbarConfig, partner.cmsV2.navbarConfig["categories"]["giftcards"]);
  } else if (route.path === "/collections/festiveSales") {
    Object.assign(navbarConfig, partner.cmsV2.navbarConfig["categories"]["fclp"]);
  } else if (route.path.toLowerCase().startsWith("/collections/fs") && route.params.id) {
    Object.assign(navbarConfig, partner.cmsV2.navbarConfig["categories"][route.params.id]);
  }

  activeBgColor.value =  partner.cmsV2.navbarConfig["default"].activeIconBgColor;
  // console.log("Partner Data:", partner.cmsV2.navbarConfig["homepage"]);
};

const isColorType = () => {
  let hex = activeBgColor.value.replace('#', '');

  const r = parseInt(hex.substr(0, 2), 16);
  const g = parseInt(hex.substr(2, 2), 16);
  const b = parseInt(hex.substr(4, 2), 16);

  const luminance = (0.299 * r + 0.587 * g + 0.114 * b);
  return luminance > 186 ? '#000000' : '#FFFFFF';
}

const getComponentStyle = (style) => {
  if (isDark.value) {
    if (style?.backgroundTypesDark == 'solid') {
      return {
        backgroundColor: `${style?.bgColorDark ? style?.bgColorDark : '#FFFFFF'}`,
        color: `${style?.textColorDark ? style?.textColorDark : '#000000'}`,
      }
    }
    if (style?.backgroundTypesDark == 'linear') {
      return {
        background: `linear-gradient(${style?.gradientAngleDark}deg,${style?.bgColorDark},${style?.bgColorDark2})`,
        color: `${style?.textColorDark ? style?.textColorDark : '#000000'}`,
      }
    }
  } else {
    if (style?.backgroundTypes == 'solid') {
      return {
        backgroundColor: `${style?.bgColor ? style?.bgColor : '#FFFFFF'}`,
        color: `${style?.textColor ? style?.textColor : '#000000'}`,
      }
    }
    if (style?.backgroundTypes == 'linear') {
      return {
        background: `linear-gradient(${style?.gradientAngle}deg,${style?.bgColor},${style?.bgColor2})`,
        color: `${style?.textColor ? style?.textColor : '#000000'}`,
      }
    }
  }
}
onMounted(async () => {

  // Initialize Google Analytics user state
  initGAEvents();

  geoStore.init();

  await nextTick()
  if (headerRef.value) {
    headerHeight.value = headerRef.value.offsetHeight
  }
  nuxtApp.hook('page:finish', () => {
    nextTick(() => {
      if (headerRef.value) {
        headerHeight.value = headerRef.value.offsetHeight
      }
    })
  })
  navIcons.getFooterNavIcons();
  getPartner()

  // This is vital for dynamic content in the footer slot
  updateFooterHeight();
  window.addEventListener("resize", updateFooterHeight);

const handleScroll = (scrollTop = 0) => {

  if (scrollTop > 100 &&
  (paths.includes(route.path) || route.path.startsWith("/categories/search-v2"))) {
    isVisible.value = true;
  } else {
    isVisible.value = false;
  }
  lastScrollPosition.value = scrollTop;
  };


window.addEventListener("scroll", () => {
  const scrollTop = window.pageYOffset || document.documentElement.scrollTop
  handleScroll(scrollTop)
})

const container = document.querySelector(".overflow-y-auto")

if (container) {
  container.addEventListener("scroll", (e) => {
    handleScroll(e.target.scrollTop)
  })
}

nextTick(() => {
  if (route.path === "/categories/search-v2") {

    const container = document.querySelector(".overflow-y-auto")

    if (container) {
      container.addEventListener("scroll", (e) => {
        handleScroll(e.target.scrollTop)
      })
    }
  }
})

nextTick(() => {
  const mainEl = document.querySelector("main")

  if (mainEl) {
    mainEl.addEventListener(
      "scroll",
      (e) => {
        const target = e.target

        const scrollTop =
          target === document ||
          target === document.body ||
          target === window
            ? window.pageYOffset || document.documentElement.scrollTop
            : target.scrollTop

        handleScroll(scrollTop)
      },
      true // ✅ THIS IS THE KEY (captures child scrolls)
    )
  }
})


handleScroll(
  container?.scrollTop ||
  window.pageYOffset ||
  document.documentElement.scrollTop
)

})
const isMobileSearchV2 = computed(() =>
  isMobile && route.path === '/categories/search-v2'
)

const scrollToTop = () => {

GoogleAnalytics.cta({
  [EventParameter.CTA_NAME]: "back_to_top",
  [EventParameter.LAST_SCROLL_POSITION]: lastScrollPosition.value,
})

const mainEl = document.querySelector("main")

let scrolled = false

if (mainEl) {
  const scrollables = mainEl.querySelectorAll("*")

  scrollables.forEach((el) => {
    if (el.scrollTop > 0) {
      el.scrollTo({
        top: 0,
        behavior: "smooth"
      })
      scrolled = true
    }
  })
}

if (!scrolled) {
  window.scrollTo({
    top: 0,
    behavior: "smooth"
  })
}
}

const financeApp = computed(() => ['finance-app-dashboard'].includes(safeRouteName.value));
const hasNoBottom = computed(() =>
  ["index", "collections-rebelfoods", "account-orders"].includes(safeRouteName.value)
);

const cart = useCart();
const cartItemCount = computed(() => {
  return cart.itemCount;
});

const showFooterNavigation = computed(() => {
  // check for default pre-handlers first
  const defaultFooterRoutePreHandler =
    footerNavPreHandlers.find((handler) => handler.routeName === "__all__") ||
    {};
  const defaultPreHandlers = defaultFooterRoutePreHandler.preHandlers || [];
  const shouldShowDefault = defaultPreHandlers.every((handler) => handler());
  if (!shouldShowDefault) {
    return false;
  }
  // Check if the current route has specific pre-handlers
  const routeName = route.name;
  const footerRoutePreHandler =
    footerNavPreHandlers.find((handler) => handler.routeName === routeName) ||
    {};
  const preHandlers = footerRoutePreHandler.preHandlers || [];
  const shouldShow = preHandlers.every((handler) => handler() !== false);
  return shouldShow;
});

const isActiveFooterItem = (item) => {
  return route.path === item.name;
};
const handleFooterClick = async (item) => {
  const routeName = item?.name;
  const ctaText = item?.label || routeName || 'nav_item';

  useAnalytics(analyticsEvents.NAV_BAR_CLICK, {
    cta_text: ctaText,
    placement: 'footer',
  });

  if (!routeName) return;

  const protectedRoutes = [
    "/account/orders",
    "/account/profile",
    "/account/tickets",
    "/support/raise_a_request",
    "/account/profile",
    "/select-location",
  ];

  const authToken = auth && auth.access_token;

  // Check if clicking on "My Orders" or any protected route
  if (!authToken && protectedRoutes.includes(routeName)) {
    setPostAuthRedirect({path: routeName, });
    isPopupOpen.value = true; // Open login overlay
    return;
  }

  // Otherwise, proceed with normal navigation
  await navigateTo({ path: routeName });
};

const initGAEvents = () => {
  // Initialize Google Analytics events here
  const { GoogleAnalyticsInit } = useGoogleAnalytics();
  GoogleAnalyticsInit();
  const GAPayload = {
    city: location?.city?.name ?? "",
    area_code: location?.area_code ?? ""
  };
  GoogleAnalytics.pageView(GAPayload);
};

onUpdated(() => {
  // This is vital for dynamic content in the footer slot
  updateFooterHeight();
});

onUnmounted(() => {
  window.removeEventListener("resize", updateFooterHeight);
});

const props = defineProps({
  page: String,
})
</script>

<style>
.scrollToTop {
  /* border-radius: 50px; */
  width: 100px;
  z-index: 50;
  /* right: 20px; */
  position: fixed;
  font-size: 12px;
  padding: 5px;
}

/* .scrollToTop {
  position: fixed;
  bottom: 20px;
  left: 20px;
  z-index: 50;
  background-color: rgba(
    147,
    51,
    234,
    0.5
  );
  border-radius: 50%;
  padding: 12px;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
} */
.mTop {
  margin-top: 2px;
}
</style>
